import {RootButton} from "@ui/buttons/RootButton";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const WebRTCSupportPopup = ({errorMessage, close}) => {
  const {t} = useTranslation();

  return (
    <div className={styles.webrtcSupportPopup}>
      <h2>{errorMessage}</h2>

      <h2 dangerouslySetInnerHTML={{__html: t("popup.webrtc.desc")}} />

      <RootButton
        onClick={close}
        txt={t("button.continue_without_avatar")}
      />
    </div>
  );
};
